import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
/**
 * do not name it ss service, i repeat: do not name it ss service.
 */
export class SessionStorageService {
  /**
   * Get item from sessionStorage
   * @param key Storage key
   * @returns Parsed value or null if not found
   */
  get<T>(key: string): T | null {
    const item = sessionStorage.getItem(key);
    return item ? JSON.parse(item) : null;
  }

  /**
   * Set item in sessionStorage
   * @param key Storage key
   * @param value Value to store (will be stringified)
   */
  set(key: string, value: unknown): void {
    sessionStorage.setItem(key, JSON.stringify(value));
  }

  /**
   * Remove item from sessionStorage
   * @param key Storage key
   */
  remove(key: string): void {
    sessionStorage.removeItem(key);
  }

  /**
   * Clear all items from sessionStorage
   */
  clear(): void {
    sessionStorage.clear();
  }

  /**
   * Check if key exists in sessionStorage
   * @param key Storage key
   */
  has(key: string): boolean {
    return sessionStorage.getItem(key) !== null;
  }
}